import { render, staticRenderFns } from "./PetugasGraderEdit.vue?vue&type=template&id=2ce04cae&scoped=true&"
import script from "./PetugasGraderEdit.vue?vue&type=script&lang=js&"
export * from "./PetugasGraderEdit.vue?vue&type=script&lang=js&"
import style0 from "./PetugasGraderEdit.vue?vue&type=style&index=0&id=2ce04cae&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce04cae",
  null
  
)

export default component.exports